import { render, staticRenderFns } from "./privacidadES.vue?vue&type=template&id=658999c2&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "privacidadES.vue"
export default component.exports